import type { TopologyOrderCode } from "interfaces/product/product.types";
import type {
  TopologyNode,
  Topology,
} from "interfaces/product/topology/topology.types";
import type { Accessory } from "interfaces/product/accessory/accessory.types";

export const hasPasteMenuHighlight = (node: TopologyNode) => {
  if (Array.isArray(node.menu)) {
    for (const item of node.menu) {
      if (
        [9, 6].includes(item.id) &&
        item.enabled === true &&
        item.highlight === true
      ) {
        return true;
      }
    }
  }
  if (Array.isArray(node.configurations)) {
    for (const item of node.configurations) {
      if (hasPasteMenuHighlight(item)) {
        return true;
      }
    }
  }

  return false;
};

export type UpdateTopologyItemOrderCodeProps = {
  topology: Topology[];
  id: string;
  orderCode: TopologyOrderCode;
  pimId: string;
  presentation: string;
  selectedAccessories: Accessory[];
};

export const updateTopologyItemOrderCode = ({
  topology,
  id,
  orderCode,
  pimId,
  presentation,
  selectedAccessories,
}: UpdateTopologyItemOrderCodeProps) => {
  const updateConfig = (configList: TopologyNode[]): TopologyNode[] =>
    configList.map((item: TopologyNode) => {
      if (item.id === id) {
        return {
          ...item,
          orderCode,
          presentation,
          pimId,
          selectedAccessories,
        } as TopologyNode;
      }

      if (Array.isArray(item.configurations)) {
        return {
          ...item,
          configurations: updateConfig(item.configurations),
        };
      }

      return item;
    });

  return topology.map((topoItem: Topology) => {
    if (Array.isArray(topoItem.configurations)) {
      return {
        ...topoItem,
        configurations: updateConfig(topoItem.configurations),
      };
    }
    return topoItem;
  });
};
